import ActionLink from './ActionLink';
import { IMAGE_SHAPES, IMAGE_SIZES } from '@/components/dorsaImage/imageTypes';
import concatClassName from '@/helpers/concatClassName';
import DorsaImage from '@/components/dorsaImage/DorsaImage';

const CampaignCard = ({ id, actionDestination, imageSrc, alt, className }) => {
    return (
        <ActionLink
            to={actionDestination}
            className={`small-list-card${concatClassName(className)}`}
            id={id}>
            <DorsaImage
                className="campaign-card-img"
                src={imageSrc}
                alt={alt}
                config={{
                    shape: IMAGE_SHAPES.SQUARE,
                    size: IMAGE_SIZES.SIZE_3
                }}
            />
        </ActionLink>
    );
};

export default CampaignCard;
